import { MediaType } from '@cobliteam/common-types';
import { Divider, Typography } from '@cobliteam/ui/components';
import { useFormContext } from '@cobliteam/ui/form';
import Icon from '@cobliteam/ui/icons';
import { format } from '@cobliteam/utils/date';
import type { FormSchemaType } from '../mediaRequestSchema';

const MEDIA_TYPE_LABELS = {
  [MediaType.FOOTAGE_VIDEO]: 'Vídeo de um trecho',
  [MediaType.TIMELAPSE]: 'Resumo de um trecho',
};

const MediaRequestInfo = () => {
  const { watch } = useFormContext<FormSchemaType>();

  const vehicle = watch('vehicle');
  const date = watch('date');
  const mediaType = watch('mediaType');

  return (
    <div className='space-y-1'>
      <div className='flex items-center justify-between'>
        <div className='flex items-center gap-1'>
          <Typography variant='description-title'>Solicitação para </Typography>
          <div className='flex items-center gap-1'>
            <Icon name='car-front' color='black' />
            <Typography variant='description-title' className='font-bold'>
              {vehicle?.licensePlate || vehicle?.cobliId} | {vehicle?.model.name}
            </Typography>
          </div>
          {date && (
            <>
              <Typography variant='description-title'>em</Typography>
              <div className='flex items-center gap-1'>
                <Icon name='calendar-days' color='black' />
                <Typography variant='description-title' className='font-bold'>
                  {format(date, 'dd/MM/yyyy')}
                </Typography>
              </div>
            </>
          )}
        </div>

        <div className='flex items-center gap-1'>
          <Typography variant='description-title'>Categoria do vídeo:</Typography>
          <Typography variant='description-title' className='font-bold'>
            {MEDIA_TYPE_LABELS[mediaType]}
          </Typography>
        </div>
      </div>
      <Divider />
    </div>
  );
};

export default MediaRequestInfo;
